import * as React from 'react'

import type { CommonDeps } from '../base/CommonDeps'
import { TopBar } from '../page/TopBar'
import { TopBarTitle } from '../page/TopBarTitle'
import { TopBarBackButton } from '../page/TopBarButtons'

interface Props {
    deps: CommonDeps
    title: string
    onBack: () => void
    rightButton?: React.ReactElement<unknown>
    children: React.ReactNode
}

export function ExecutionPageTopBar({ deps, onBack, title, rightButton, children }: Props) {
    return (
        <div data-title={title}>
            <TopBar
                deps={deps}
                leftButton={() => <TopBarBackButton onClick={onBack} />}
                rightButton={() => rightButton ?? <zaptic-spacer></zaptic-spacer>}
            >
                {() => <TopBarTitle deps={deps} header={title} />}
            </TopBar>
            {children}
        </div>
    )
}
